import { estadoLaudoConfirmado } from "./prontuario-laudo-operations";

const endpoints = { preparar: "prepararGravacaoTexto", salvar: "salvarTextoConfirmado", consultar: "consultarGravacaoTexto" };
export async function requisitarGravacaoTexto(api, jwt, { etapa, dados }) {
  if(!Object.prototype.hasOwnProperty.call(endpoints, etapa) || !jwt.getToken()) {
    throw Object.assign(new Error("Sessão indisponível. Nenhum texto foi enviado."), { antesDoEnvio: true });
  }
  try { api.setHeader(); } catch(error) { error.antesDoEnvio = true; throw error; }
  const { data } = await api.postOnce("atendimentos/access/" + endpoints[etapa], dados, { timeout: 120000 });
  if(data?.RESULTADO === false && data.ESTADO === "FALHA") {
    throw Object.assign(new Error(data.MENSAGEM || "A gravação foi recusada."), { rejeitada: true });
  }
  return data;
}

const clone = value => JSON.parse(JSON.stringify(value));
const idValido = id => /^[1-9]\d*$/.test(String(id));
const mesmaIdentificacao = (a, b) => a != null && b != null && String(a) === String(b);
export function textoConfirmado(resposta, dados) {
  const salvo = resposta?.DIVERSOS, exame = dados.EXAMES[0], texto = exame.TEXTOS[0];
  return resposta?.RESULTADO === true && resposta.ESTADO === "CONFIRMADO" && salvo &&
    idValido(salvo.ID_DIVERSOS) && mesmaIdentificacao(salvo.ID_DIVERSOS, texto.ID_DIVERSOS) &&
    mesmaIdentificacao(salvo.ID_PACIENTE, dados.ID_PACIENTE) && mesmaIdentificacao(salvo.ID_PRODUTO, exame.ID_PRODUTO) &&
    salvo.ESPECIAL === texto.CONTEUDO && salvo.TITULO === texto.TITULO && salvo.LAUDO_STATUS === texto.STATUS;
}

// Efeitos posteriores nunca provocam uma nova gravação do texto.
export async function concluirPublicacaoTexto(vm, req, vigente) {
  if(!req.liberacao) { return []; }
  const dados = { ...req.liberacao, ID_DIVERSOS: req.dados.EXAMES[0].TEXTOS[0].ID_DIVERSOS };
  try {
    try { await vm.enviarOperacaoLaudo({ tipo: "liberar", dados }); } catch(error) {
      if(error.antesDoEnvio || error.rejeitada) { throw error; }
    }
    if(!vigente()) { return []; }
    let atual = await vm.consultarLeituraEditorTexto({ recurso: "pacienteLaudo", dados });
    if(!estadoLaudoConfirmado({ tipo: "liberar", dados }, atual)) { throw new Error(); }
    if(!vigente() || !req.pdf) { return []; }
    const anterior = clone(atual);
    const pdfDados = { ...dados, ID_PACIENTE_LAUDO: atual.ID_PACIENTE_LAUDO, ASSINAR: req.pdf === "2" };
    if(req.pdf === "2") {
      req.assinaturaRetida = atual.ID_PACIENTE_LAUDO;
      await vm.definirAssinaturaImediata?.({ id: req.assinaturaRetida, ativa: true });
    }
    let resposta;
    try { resposta = await vm.enviarOperacaoLaudo({ tipo: "pdf", dados: pdfDados }); } catch(error) {
      if(error.antesDoEnvio || error.rejeitada) { throw error; }
    }
    if(!vigente()) { return []; }
    atual = await vm.consultarLeituraEditorTexto({ recurso: "pacienteLaudo", dados });
    if(!estadoLaudoConfirmado({ tipo: "pdf", dados: pdfDados, anterior, resposta }, atual)) { throw new Error(); }
    if(req.pdf === "2" && vigente()) { req.laudoParaAssinar = clone(atual); }
    return [];
  } catch(error) {
    return ["Texto salvo. A liberação ou o PDF não foram confirmados. Consulte o estado do laudo e use os botões específicos; não é necessário salvar o texto novamente."];
  }
}

const controladores = new WeakMap();
const chave = vm => JSON.stringify([vm.$route.fullPath, vm.paciente.ID_PACIENTE, vm.idAgenda,
  vm.agendaExame.ID_AGENDA_EXAME, vm.agendaExame.ID_PRODUTO, vm.textoIncluindo.ID_DIVERSOS || "novo"]);
export function gravacaoTexto(vm, capturar) {
  if(controladores.has(vm)) { return controladores.get(vm); }
  const pendentes = new Map();
  let corrente;
  const estado = (mensagem = "", consultar = false, ocupada = false) => { vm.gravacaoTexto = { mensagem, consultar, ocupada }; };
  function sincronizar() {
    corrente = null;
    const req = pendentes.get(chave(vm));
    if(req) { Object.assign(vm.textoIncluindo, clone(req.rascunho)); }
    estado(req ? "Esta gravação aguarda confirmação. O texto digitado foi preservado; consulte o resultado." : "", !!req);
  }
  function iniciar(req, consulta) {
    const token = {}, contexto = capturar();
    corrente = token;
    const vigente = () => corrente === token && contexto();
    estado(consulta ? "Consultando a gravação…" : "Salvando texto…", false, true);
    vm.isLoading = true;
    token.promise = Promise.resolve().then(async () => {
      let enviado = consulta;
      try {
        let resposta;
        if(!consulta) {
          const originalId = req.dados.EXAMES[0].TEXTOS[0].ID_DIVERSOS;
          // Só inclusões precisam reservar um ID; o conteúdo não é enviado na preparação.
          const audio = req.rascunho.PEP_AUDIO;
          const preparado = audio ? { ID_DIVERSOS: audio.documento, NOVO: audio.novo } : originalId ? { ID_DIVERSOS: originalId, NOVO: false } :
            await vm.requisitarGravacaoTexto({ etapa: "preparar", dados: {} });
          if(!vigente()) { return false; }
          if(!idValido(preparado?.ID_DIVERSOS) || typeof preparado.NOVO !== "boolean") { throw new Error("Não foi possível preparar o texto. Nenhuma gravação foi enviada."); }
          if(originalId && (!mesmaIdentificacao(originalId, preparado.ID_DIVERSOS) || preparado.NOVO)) { throw new Error("Identificação do texto divergente. Nenhuma gravação foi enviada."); }
          Object.assign(req.dados.EXAMES[0].TEXTOS[0], preparado);
          pendentes.set(req.chave, req);
          enviado = true;
          try { resposta = await vm.requisitarGravacaoTexto({ etapa: "salvar", dados: req.dados }); }
          catch(error) {
            if(error.antesDoEnvio || error.rejeitada) { pendentes.delete(req.chave); enviado = false; throw error; }
          }
        }
        if(!vigente()) { return false; }
        if(!textoConfirmado(resposta, req.dados)) {
          resposta = await vm.requisitarGravacaoTexto({ etapa: "consultar", dados: req.dados });
          req.recuperada = true;
        }
        if(!vigente()) { return false; }
        if(!textoConfirmado(resposta, req.dados)) { throw new Error(); }
        req.confirmada = true;
        let avisos = Array.isArray(resposta.AVISOS) ? resposta.AVISOS.slice() : [];
        if(req.recuperada) {
          avisos.push("Gravação confirmada por consulta. Confira o histórico/status e, se solicitados, a liberação e o PDF. Nenhuma dessas operações foi repetida.");
        } else {
          avisos = avisos.concat(await concluirPublicacaoTexto(vm, req, vigente));
        }
        if(!vigente()) { return false; }
        pendentes.delete(req.chave);
        // Adota o ID antes dos efeitos de interface; uma falha visual não pode duplicar a inclusão.
        estado(avisos.join(" "));
        vm.isLoading = false;
        vm.preparandoTexto = false;
        corrente = null;
        await vm.aplicarTextoConfirmado(req, resposta.DIVERSOS, avisos);
        return true;
      } catch(error) {
        if(vigente()) {
          estado(enviado ? "Não foi possível confirmar a gravação. Seu texto foi preservado. Consulte o resultado antes de continuar." : error.message || "Não foi possível preparar a gravação.", enviado);
        }
        return false;
      } finally {
        if(req.assinaturaRetida) {
          await vm.definirAssinaturaImediata?.({ id: req.assinaturaRetida, ativa: false, concluida: !!req.assinaturaConcluida });
          req.assinaturaRetida = null;
          vm.checkDocumentsSignPending?.().catch(() => {});
        }
        if(corrente === token) { corrente = null; vm.isLoading = false; vm.gravacaoTexto.ocupada = false; }
      }
    });
    return token.promise;
  }
  function salvar(agenda, continuar, rascunho) {
    if(corrente) { return corrente.promise; }
    const key = chave(vm);
    if(pendentes.has(key)) { sincronizar(); return Promise.resolve(false); }
    const exame = clone(agenda), liberacao = exame.LIBERAR_LAUDO, pdf = exame.GERAR_PDF;
    delete exame.LIBERAR_LAUDO; delete exame.GERAR_PDF; delete exame.SALVAR_CONTINUAR;
    exame.TEXTOS = [clone(rascunho)];
    // CONTEUDO do editor é HTML; codificar somente a cópia, inclusive quando parece base64.
    exame.TEXTOS[0].CONTEUDO = window.b64EncodeUnicode(rascunho.CONTEUDO || "");
    const req = { chave: key, rascunho: clone(rascunho), continuar, liberacao, pdf,
      contexto: { rota: vm.$route.fullPath, paciente: vm.paciente.ID_PACIENTE, agenda: vm.idAgenda, direto: !!vm.salvarTextoDiretamente,
        filaAtendimento: !vm.salvarTextoDiretamente && !vm.$route.params.idAgendaExame, textoLocal: rascunho.ID },
      dados: { ID_PACIENTE: vm.paciente.ID_PACIENTE, ID_AGENDA: vm.idAgenda,
        ...(rascunho.PEP_AUDIO || (!vm.salvarTextoDiretamente && !vm.$route.params.idAgendaExame) ? { ID_ATENDIMENTO: vm.idAtendimento } : {}), EXAMES: [exame] } };
    return iniciar(req, false);
  }
  function recuperarAudio(dados) {
    if(corrente || !mesmaIdentificacao(dados.ID_PACIENTE, vm.paciente.ID_PACIENTE) || !mesmaIdentificacao(dados.ID_ATENDIMENTO, vm.idAtendimento) ||
      !mesmaIdentificacao(dados.EXAMES?.[0]?.ID_PRODUTO, vm.agendaExame.ID_PRODUTO) ||
      (vm.textoIncluindo.ID_DIVERSOS && !mesmaIdentificacao(vm.textoIncluindo.ID_DIVERSOS, dados.EXAMES[0].TEXTOS[0].ID_DIVERSOS))) { throw new Error("Confira o paciente, atendimento e documento para recuperar esta gravação."); }
    const text = clone(dados.EXAMES[0].TEXTOS[0]);
    if(!text.PEP_AUDIO) { throw new Error("Gravação sem vínculo de áudio."); }
    text.CONTEUDO = window.b64DecodeUnicode(text.CONTEUDO);
    const key = chave(vm), localId = vm.textoIncluindo.ID;
    const req = { chave: key, rascunho: text, continuar: true, dados: clone(dados), contexto: {
      rota: vm.$route.fullPath, paciente: vm.paciente.ID_PACIENTE, agenda: vm.idAgenda,
      direto: !!vm.salvarTextoDiretamente, filaAtendimento: !vm.salvarTextoDiretamente && !vm.$route.params.idAgendaExame, textoLocal: localId } };
    // Keep the current key until confirmation adopts the durable document identifier.
    Object.assign(vm.textoIncluindo, text, { ID: localId, ID_DIVERSOS: vm.textoIncluindo.ID_DIVERSOS });
    pendentes.set(key, req);
    estado("Texto enviado recuperado. Consulte a gravação antes de continuar.", true);
    return true;
  }
  const controlador = { salvar, sincronizar, recuperarAudio, pendente: () => pendentes.has(chave(vm)),
    consultar: () => corrente ? corrente.promise : pendentes.has(chave(vm)) ? iniciar(pendentes.get(chave(vm)), true) : Promise.resolve(false),
    invalidar: () => { corrente = null; } };
  controladores.set(vm, controlador);
  return controlador;
}
